import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogoutService } from 'src/app/core/services/logout.service';

@Component({
  selector: 'app-nav-small',
  templateUrl: './nav-small.component.html',
  styleUrls: ['./nav-small.component.less'],
  standalone: false
})
export class NavSmallComponent implements OnInit {
  loggedIn: boolean;
  loggedInValue = false;
  constructor(public router: Router, private logoutService: LogoutService) { }

  ngOnInit() {
  }
  logout() {
    this.logoutService.logoutSvc().subscribe();

    this.router.navigate(['/login'], { replaceUrl: true });
    this.loggedInValue = false;
  }

}
